import { TagToComponentMap } from "nwon-html-to-react";

export const mappedParagraphs: TagToComponentMap = {
  p: ({ children, attributes }) => {
    // Default case
    return <p {...attributes}>{children}</p>;
  },
};
